/**
 * `pickName` filters out strings that look like opaque identifiers
 * (UUIDs, raw chat ids) so they don't leak into user-facing labels.
 * Used by the chat header / card / settings panel where the
 * backend's `customerName`-like fields can legitimately come back
 * as an id when no human-set name is on file.
 *
 * A real phone like "+992 90 123 45 67" passes — it has non-digit
 * chars. A bare numeric handle ≥ 6 digits doesn't.
 */
export function pickName(s: string | undefined | null): string | undefined {
  if (!s) return undefined
  const trimmed = s.trim()
  if (!trimmed) return undefined
  if (looksLikeId(trimmed)) return undefined
  return trimmed
}

export function looksLikeId(s: string): boolean {
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(s)) return true
  if (/^\d{6,}$/.test(s)) return true
  return false
}
